import { boot } from "quasar/wrappers";
import * as VueGoogleMaps from "vue3-google-map";

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(({ app }) => {
  app.use(VueGoogleMaps, {
    load: {
      key: process.env.GOOGLE_MAP_API_KEY,
    },
  });
});
